import { DataSnapshot } from 'firebase/database';

import { Encryption } from '@core';
import { DataBaseNodes } from '@lib';
import { AssetCollection, Site, SourceUnsubscribe } from '@type';

import { Preferences } from '../types';
import { BaseGateway } from './base.gateway';

export class AssetGateway extends BaseGateway {
  removeAssetList = async () => {
    return this.sourceService.removeData(
      `${DataBaseNodes.Patients}/${this.config.patientSourceUUID}/${DataBaseNodes.Asset}`
    );
  };

  requestAssetList = async (
    siteUuid: string,
    siteId: number,
    search: string
  ) => {
    const payload = {
      preference: Preferences.Asset.AssetRequest,
      type: Preferences.Asset.GetAssets,
      searchTerm: search,
      institutionId: siteId,
    };

    await this.removeAssetList();

    return await this.sendRequest(
      siteUuid,
      payload,
      DataBaseNodes.Request,
      this.config.patientSourceUUID
    );
  };

  subscribeToAssetAdded = (
    site: Site,
    callback: (assets: AssetCollection | null) => void
  ): SourceUnsubscribe => {
    return this.sourceService.subscribeToChildAdded(
      `${DataBaseNodes.Patients}/${this.config.patientSourceUUID}/${DataBaseNodes.Asset}`,
      (snapshot: DataSnapshot) => {
        if (!snapshot.exists()) return [];

        const data = snapshot.val() as { document: string };

        const assets = Encryption.decryptAndParseObject<AssetCollection>(
          data.document,
          site.sharedSecretKey
        );

        callback(assets);
      }
    );
  };
}
